class PriceDisplay extends HTMLElement {
  connectedCallback() {
    this.textEl = this.querySelector("[data-pd-text]");
    this.priceEl = this.querySelector("[data-pd-price]");
    this.compareEl = this.querySelector("[data-pd-compare]");
    this.saveEl = this.querySelector("[data-pd-save]");
    this.separator = this.dataset.separator || " · ";
    this.customText = (this.dataset.customText || "").trim();
    this.variants = this.readData();
    this.supply = null;

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event && event.data ? event.data.variant : null;
        if (variant && variant.id) this.render(variant.id);
      });
    }

    this.onVariantEvent = (event) => {
      const detail = event ? event.detail : null;
      const id = detail && detail.variant ? detail.variant.id : detail ? detail.id : null;
      if (id) this.render(id);
    };
    document.addEventListener("variant:change", this.onVariantEvent);

    this.onSupplyEvent = (event) => {
      this.supply = event && event.detail ? event.detail : null;
      this.renderSupply();
    };
    document.addEventListener("wt:supply:change", this.onSupplyEvent);

    if (window.wtSupplyState) {
      this.supply = window.wtSupplyState;
      this.renderSupply();
    }
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === "function") this.unsubscribe();
    document.removeEventListener("variant:change", this.onVariantEvent);
    document.removeEventListener("wt:supply:change", this.onSupplyEvent);
  }

  readData() {
    const script = this.querySelector("[data-price-display-data]");
    if (!script) return {};
    try {
      return JSON.parse(script.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  render(variantId) {
    if (this.supply) return;
    if (!this.textEl) return;

    const data = this.variants[String(variantId)] || {};
    const parts = [data.unit, data.servings, this.customText]
      .map((part) => (part || "").trim())
      .filter(Boolean);

    this.textEl.textContent = parts.join(this.separator);
    this.hidden = parts.length === 0 && !this.priceEl;
  }

  renderSupply() {
    const supply = this.supply;
    if (!supply) return;

    if (this.priceEl && supply.price) this.priceEl.textContent = supply.price;

    if (this.compareEl) {
      const compare = (supply.compare || "").trim();
      this.compareEl.textContent = compare;
      this.compareEl.hidden = compare.length === 0;
    }

    if (this.saveEl) {
      const save = (supply.saveAmount || "").trim();
      this.saveEl.textContent = save;
      this.saveEl.hidden = save.length === 0;
    }

    if (this.textEl) {
      const parts = [supply.perDay, supply.servings, this.customText]
        .map((part) => (part || "").trim())
        .filter(Boolean);
      this.textEl.textContent = parts.join(this.separator);
    }

    this.hidden = false;
  }
}

if (!customElements.get("price-display")) {
  customElements.define("price-display", PriceDisplay);
}
